import React from "react";

function Footer() {
  return (
    <>
      <footer>
        <div className="footer">
          <div className="zuri-logo">
            <img src="/images/Zuri.Internship_Logo.png" alt="zuri-logo" />
          </div>
          <p>HNG internship 9 Frontend Task</p>
          <div className="hng-logo">
            <img src="/images/I4G.png" alt="hng-logo" />
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
